<section class="dataFields" [formGroup]="fieldForm">
  <ng-container *ngIf="charts && charts.length > 0">
    <div class="heading">Add Your Data Fields</div>
    <mat-form-field
      id="searchDataPoints"
      style="width: 80%; height: 40px; margin-right: 10px"
      appearance="fill"
      [ngClass]="{
        noDataPoints:
          !currentDataFields ||
          (currentDataFields.length <= 0 && canAddModifiers && isVisible)
      }"
      *ngIf="!reportloading"
    >
      <input
        matInput
        name="field"
        class="search-input"
        aria-label="Search for a data field"
        placeholder="Search Fields"
        autocomplete="off"
        (keyup.enter)="search()"
        formControlName="field"
        style="margin-left: 10px"
        [hidden]="!canAddModifiers || !isVisible"
      />
      <input matInput [hidden]="canAddModifiers && isVisible" disabled />
      <fa-icon
        [icon]="faSearch"
        matPrefix
        mat-button
        class="filterMenu"
      ></fa-icon>
      <span matPrefix class="label" *ngIf="fieldLabel != ''">{{
        fieldLabel
      }}</span>
    </mat-form-field>
    <fa-icon
      [icon]="faMagnifyingGlassPlus"
      id="advancedSearch"
      mat-button
      (click)="openSearch()"
      style="cursor: pointer"
      *ngIf="canAddModifiers && isVisible"
      matTooltip="Advanced Search"
      matTooltipPosition="right"
    ></fa-icon>
    <span
      [matMenuTriggerFor]="fieldMenu"
      #fieldMenuTrigger="matMenuTrigger"
    ></span>
  </ng-container>
  <div class="noChartFieldArea" *ngIf="!charts || charts.length <= 0"></div>
  <div
    class="fieldArea"
    [ngClass]="{ collaspedInfo: !expanded }"
    *ngIf="charts && charts.length > 0"
  >
    <div class="notAvailable" *ngIf="!canAddModifiers || !isVisible">
      <ng-container *ngIf="chartType">
        You do not have access to edit this object.
      </ng-container>
      <ng-container *ngIf="!chartType">
        No data points available for text objects.
      </ng-container>
    </div>
    <div class="error">{{ error }}</div>
    <div
      cdkDropList
      class="reportField-list"
      (cdkDropListDropped)="drop($event)"
      *ngIf="canAddModifiers && isVisible"
    >
      <div
        cdkDragBoundary=".reportField-list"
        class="reportField-box"
        *ngFor="let reportField of canvasFields; let i = index"
        cdkDrag
      >
        <div class="reorder-placeholder" *cdkDragPlaceholder></div>
        <div
          class="canvasFields"
          class="canvasFields"
          id="filter-{{ i }}"
          #filter
          [ngClass]="{
            hasAlias: reportField.alias,
            selected: selectedIndex == i
          }"
        >
          <div class="left">
            <app-datapoint-icons
              [type]="reportField.type"
            ></app-datapoint-icons>
          </div>
          <div
            class="right"
            matTooltip="{{ reportField.name }}"
            matTooltipPosition="above"
          >
            <div class="title">{{ reportField.name }}</div>
            <div class="type">{{ reportField.dataSet.data.name }}</div>
          </div>
          <div class="far-right">
            <fa-icon
              [icon]="faEdit"
              (click)="renameDataField($event, reportField, i)"
              matTooltip="Rename this field"
              matTooltipPosition="above"
            ></fa-icon>
            <fa-icon
              [icon]="faTrash"
              (click)="removeDataField($event, i, reportField.id)"
            ></fa-icon>
          </div>
        </div>
      </div>
    </div>
  </div>

  <mat-menu #fieldMenu="matMenu" yPosition="below">
    <div class="classOnlyForTheWidth"></div>
    <span class="menuHeader"
      >Showing results for "{{ fieldForm.controls["field"].value }}"</span
    >
    <cdk-virtual-scroll-viewport
      #scroller
      [itemSize]="50"
      [maxBufferPx]="600"
      [minBufferPx]="600"
      class="search-viewport"
    >
      <div *cdkVirtualFor="let field of dataFields; templateCacheSize: 5">
        <div
          (click)="moveItemtoList(field.id, true)"
          [ngStyle]="{
            display: itemInReport(field.id)
          }"
          class="searchMenu"
        >
          <div class="left">
            <app-datapoint-icons [type]="field.type"></app-datapoint-icons>
          </div>
          <div
            class="right"
            [matTooltipShowDelay]="500"
            matTooltip="{{ field.name }}"
            matTooltipPosition="above"
          >
          <span class="title">{{ field.name }}</span>
          <span class="type">
            <ng-container *ngIf="field.stream_dir_data; else defaultView">
              <ng-container *ngIf="field.stream_dir_data === 'up'">
                {{ field.dataSet?.data?.name }} > {{ field.linkedDataset?.data?.name }}
              </ng-container>
              <ng-container *ngIf="field.stream_dir_data === 'down'">
                {{ field.linkedDataset?.data?.name }} > {{ field.dataSet?.data?.name }}
              </ng-container>
            </ng-container>
            <ng-template #defaultView>
              {{ field.dataSet?.data?.name }}
            </ng-template>
          </span>
          </div>
        </div>
      </div>
      <div class="spinner-item">
        <mat-progress-spinner
          [mode]="'indeterminate'"
          [diameter]="50"
          *ngIf="loading"
        >
        </mat-progress-spinner>
      </div>
    </cdk-virtual-scroll-viewport>
  </mat-menu>
</section>
